var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleteInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "262px",
    height: "208px",
    viewBox: "0 0 262 208",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0001583%",
    x2: "142.499799%",
    y2: "50.0001583%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1B36",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14375F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "137.760346%",
    y1: "121.074912%",
    x2: "-79.7741412%",
    y2: "-57.570725%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "127.592774%",
    y1: "171.289669%",
    x2: "-64.0349749%",
    y2: "-132.911128%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "147.151079%",
    y1: "23.1063447%",
    x2: "-94.6071942%",
    y2: "91.2962288%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.7597403%",
    y1: "-21.0819546%",
    x2: "179.772727%",
    y2: "157.582384%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-27.5898905%",
    y1: "-71.2916269%",
    x2: "164.038581%",
    y2: "232.914507%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.537,196.914 C177.119,196.914 222.177,154.499 222.177,102.178 C222.177,49.8563 177.119,7.4414 121.537,7.4414 C65.956,7.4414 20.8984,49.8563 20.8984,102.178 C20.8984,154.499 65.956,196.914 121.537,196.914 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.75,118.349 C179.91,121.548 177.573,124.266 173.888,126.41 C170.199,128.556 165.224,130.083 159.276,130.904 C147.385,132.544 131.802,131.332 115.367,126.837 C98.931,122.342 84.842,115.438 75.348,107.948 C70.599,104.202 67.039,100.34 64.895,96.599 C62.753,92.862 62.061,89.315 62.901,86.115 C63.74,82.9158 66.078,80.1974 69.763,78.0536 C73.452,75.9077 78.427,74.38 84.375,73.56 C96.266,71.9195 111.848,73.1316 128.284,77.6271 C144.72,82.1222 158.809,89.026 168.303,96.515 C173.052,100.261 176.613,104.123 178.756,107.865 C180.898,111.602 181.59,115.149 180.75,118.349 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2.60339
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.689,122.334 C193.637,133.733 182.614,142.003 166.933,146.016 C151.28,150.022 131.161,149.726 110.305,144.133 C89.449,138.539 71.878,128.727 60.323,117.423 C48.748,106.101 43.3322,93.422 46.384,82.0222 C49.435,70.6225 60.459,62.3524 76.14,58.3394 C91.793,54.3334 111.911,54.6294 132.768,60.223 C153.624,65.8165 171.195,75.629 182.75,86.932 C194.325,98.255 199.741,110.934 196.689,122.334 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2.60339
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.917,125.511 C215.363,142.524 200.419,155.139 179.724,161.693 C159.039,168.244 132.716,168.693 105.673,161.441 C78.63,154.188 56.058,140.625 41.4166,124.6 C26.768,108.567 20.128,90.162 24.6824,73.1497 C29.2367,56.1365 44.1806,43.5213 64.876,36.9675 C85.561,30.4166 111.884,29.967 138.927,37.2197 C165.97,44.4728 188.542,58.0361 203.183,74.0613 C217.832,90.094 224.472,108.498 219.917,125.511 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2.60339
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.976,207.897 C239.976,207.897 223.158,194.565 212.076,193.036 C201.11,191.524 172.206,193.297 150.758,184.196 C150.557,184.113 150.391,183.961 150.289,183.769 C150.188,183.576 150.157,183.353 150.201,183.14 C150.542,181.586 152.151,178.277 159.884,178.598 C169.949,179.033 177.664,179.166 177.664,179.166 C177.664,179.166 146.744,148.575 138.981,139.662 C137.448,137.904 136.411,136.317 135.735,134.875 C133.63,130.376 139.406,126.335 142.984,129.78 L163.929,149.93 C163.929,149.93 162.938,146.772 165.151,144.812 C167.248,142.963 172.559,143.982 175.66,147.33 C175.66,147.33 174.847,143.69 178.343,142.077 C181.84,140.465 186.433,143.251 188.382,145.059 C188.382,145.059 186.854,141.756 189.037,139.869 C191.22,137.981 197.009,139.82 198.562,140.931 C200.114,142.041 214.611,148.987 230.318,168.452 L261.092,177.993 C261.092,177.993 265.399,189.392 239.976,207.897 Z",
    id: "Path",
    fill: "#DADEE6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.000000, 83.000000)",
    fill: "#FDFEFF",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.228,0.923 C12.137,1.198 12.045,2.359 12.045,3.489 C12.045,10.577 8.993,14.335 2.736,14.976 C1.118,15.16 0.752,15.282 0.813,15.679 C0.874,16.045 1.423,16.229 2.858,16.382 C9.054,17.084 11.587,19.986 12.014,27.074 C12.106,28.846 12.289,30.435 12.411,30.526 C12.533,30.648 12.839,30.679 13.113,30.587 C13.48,30.435 13.571,29.885 13.571,28.021 C13.571,26.707 13.785,24.752 14.059,23.652 C15.128,19.009 17.661,16.901 22.728,16.382 C24.193,16.229 24.742,16.045 24.803,15.679 C24.864,15.282 24.498,15.16 22.88,14.976 C16.562,14.335 13.571,10.638 13.571,3.489 C13.571,1.168 13.388,0.434 12.808,0.434 C12.594,0.434 12.32,0.648 12.228,0.923 Z M14.761,12.318 C15.494,13.327 18.332,15.404 18.973,15.404 C19.736,15.404 19.34,15.893 18.271,16.29 C16.104,17.084 14.273,19.253 13.113,22.4 C12.869,23.011 12.686,23.286 12.686,23.041 C12.625,22.156 11.068,19.192 10.122,18.215 C9.573,17.634 8.474,16.84 7.65,16.412 L6.124,15.648 L7.589,14.946 C8.382,14.549 9.451,13.846 9.939,13.388 C10.885,12.471 12.655,9.233 12.655,8.408 C12.655,8.133 12.991,8.683 13.388,9.63 C13.754,10.577 14.395,11.768 14.761,12.318 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.781,19.437 C25.75,22.462 24.193,24.57 21.904,24.57 C20.867,24.57 20.134,24.997 20.409,25.425 C20.531,25.608 21.233,25.853 21.965,25.975 C24.468,26.341 25.414,27.533 25.75,30.832 C25.872,32.177 26.055,32.696 26.422,32.757 C26.818,32.818 26.94,32.482 27.062,30.924 C27.337,27.625 28.375,26.372 31.244,25.914 C33.045,25.639 32.862,24.783 30.969,24.57 C28.405,24.233 27.337,22.92 27.062,19.804 C26.94,18.154 26.818,17.848 26.36,17.848 C25.872,17.848 25.781,18.093 25.781,19.437 Z M28.161,24.844 C28.741,25.15 28.711,25.242 27.581,26.372 L26.391,27.563 L25.231,26.433 L24.102,25.333 L25.323,24.111 L26.544,22.859 L27.062,23.684 C27.337,24.142 27.856,24.661 28.161,24.844 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.142,128.945 C233.225,131.759 239.462,129.792 239.462,129.792 C239.462,129.792 239.076,123.261 234.991,120.45 C230.908,117.635 224.674,119.6 224.674,119.6 C224.674,119.6 225.06,126.13 229.142,128.945 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.563,105.767 C7.7922,110.075 15.7006,109.167 15.7006,109.167 C15.7006,109.167 16.7471,101.273 12.514,96.967 C8.2848,92.659 0.3803,93.565 0.3803,93.565 C0.3803,93.565 -0.6662,101.458 3.563,105.767 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.203,183.291 C130.5,183.291 127.498,186.166 127.498,189.711 C127.498,193.257 130.5,196.131 134.203,196.131 C137.906,196.131 140.908,193.257 140.908,189.711 C140.908,186.166 137.906,183.291 134.203,183.291 Z",
    id: "Path",
    fill: "#102F52",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0847,130.935 C9.924,130.935 8.1724,132.688 8.1724,134.851 C8.1724,137.013 9.924,138.767 12.0847,138.767 C14.2455,138.767 15.9971,137.013 15.9971,134.851 C15.9971,132.688 14.2455,130.935 12.0847,130.935 Z",
    id: "Path",
    fill: "#102F52",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.746,7.4667 C78.694,7.4667 77.029,5.8011 77.029,3.7465 C77.029,1.6919 78.694,0.0264 80.746,0.0264 C82.799,0.0264 84.463,1.6919 84.463,3.7465 C84.463,5.8011 82.799,7.4667 80.746,7.4667 Z",
    id: "Path",
    fill: "#102F52",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.824,69.062 C201.443,69.062 198.702,66.3185 198.702,62.9343 C198.702,59.5501 201.443,56.8066 204.824,56.8066 C208.205,56.8066 210.946,59.5501 210.946,62.9343 C210.946,66.3185 208.205,69.062 204.824,69.062 Z",
    id: "Path",
    fill: "#102F52",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.106,196.06 C183.988,196.06 182.271,194.341 182.271,192.221 C182.271,190.101 183.988,188.383 186.106,188.383 C188.224,188.383 189.94,190.101 189.94,192.221 C189.94,194.341 188.224,196.06 186.106,196.06 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.248,186.033 C63.359,186.033 60.206,182.877 60.206,178.984 C60.206,175.091 63.359,171.936 67.248,171.936 C71.137,171.936 74.29,175.091 74.29,178.984 C74.29,182.877 71.137,186.033 67.248,186.033 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.019,179.767 C129.722,179.767 128.671,178.716 128.671,177.418 C128.671,176.12 129.722,175.068 131.019,175.068 C132.315,175.068 133.366,176.12 133.366,177.418 C133.366,178.716 132.315,179.767 131.019,179.767 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.509,85.232 C219.933,85.232 218.655,83.953 218.655,82.3758 C218.655,80.7983 219.933,79.5195 221.509,79.5195 C223.085,79.5195 224.362,80.7983 224.362,82.3758 C224.362,83.953 223.085,85.232 221.509,85.232 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.451,42.0298 C192.046,42.0298 190.095,40.0779 190.095,37.6702 C190.095,35.2624 192.046,33.3105 194.451,33.3105 C196.857,33.3105 198.807,35.2624 198.807,37.6702 C198.807,40.0779 196.857,42.0298 194.451,42.0298 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1385,100.129 C41.1385,101.347 40.1522,102.334 38.9355,102.334 C37.7188,102.334 36.7324,101.347 36.7324,100.129 C36.7324,98.911 37.7188,97.924 38.9355,97.924 C40.1522,97.924 41.1385,98.911 41.1385,100.129 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3153,56.7464 C7.8197,56.7464 6.6072,55.5328 6.6072,54.0358 C6.6072,52.5388 7.8197,51.3252 9.3153,51.3252 C10.811,51.3252 12.0234,52.5388 12.0234,54.0358 C12.0234,55.5328 10.811,56.7464 9.3153,56.7464 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.873,148.801 C233.262,148.801 231.957,147.756 231.957,146.467 C231.957,145.178 233.262,144.133 234.873,144.133 C236.483,144.133 237.788,145.178 237.788,146.467 C237.788,147.756 236.483,148.801 234.873,148.801 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.062,28.0248 C138.062,30.2957 136.222,32.1366 133.954,32.1366 C131.685,32.1366 129.846,30.2957 129.846,28.0248 C129.846,25.754 131.685,23.9131 133.954,23.9131 C136.222,23.9131 138.062,25.754 138.062,28.0248 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.864,53.2833 L223.941,53.2833 C224.392,59.6882 229.151,59.7865 229.151,59.7865 C229.151,59.7865 223.903,59.8891 223.903,67.2898 C223.903,59.8891 218.656,59.7865 218.656,59.7865 C218.656,59.7865 223.412,59.6882 223.864,53.2833 Z M55.677,7.4668 L55.737,7.4668 C56.09,12.6593 59.815,12.7396 59.815,12.7396 C59.815,12.7396 55.708,12.8226 55.708,18.823 C55.708,12.8226 51.6,12.7396 51.6,12.7396 C51.6,12.7396 55.323,12.6597 55.677,7.4668 Z",
    id: "Shape",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.752,146.971 C52.671,146.516 54.7,148.145 54.7,148.145 C54.7,148.145 53.617,150.51 51.698,150.964 C49.779,151.419 47.75,149.792 47.75,149.792 C47.75,149.792 48.833,147.426 50.752,146.971 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.735,104.659 C58.035,103.486 55.437,104.306 55.437,104.306 C55.437,104.306 55.597,107.026 57.299,108.198 C59,109.37 61.597,108.552 61.597,108.552 C61.597,108.552 61.436,105.831 59.735,104.659 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.202,98.54 C179.634,95.924 174.83,96.475 174.83,96.475 C174.83,96.475 174.195,101.27 176.766,103.885 C179.334,106.502 184.135,105.951 184.135,105.951 C184.135,105.951 184.771,101.157 182.202,98.54 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.774,94.162 C67.515,94.162 69.737,92.039 69.737,89.421 C69.737,86.802 67.515,84.679 64.774,84.679 C62.033,84.679 59.812,86.802 59.812,89.421 C59.812,92.039 62.033,94.162 64.774,94.162 Z",
    id: "Path",
    fill: "#102F52",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.27,40.505 C224.011,40.505 226.233,38.2811 226.233,35.5377 C226.233,32.7943 224.011,30.5703 221.27,30.5703 C218.53,30.5703 216.308,32.7943 216.308,35.5377 C216.308,38.2811 218.53,40.505 221.27,40.505 Z",
    id: "Path",
    fill: "#102F52",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5488,166.845 C39.0405,166.845 41.0605,168.967 41.0605,171.586 C41.0605,174.205 39.0405,176.328 36.5488,176.328 C34.0571,176.328 32.0371,174.205 32.0371,171.586 C32.0371,168.967 34.0571,166.845 36.5488,166.845 Z",
    id: "Path",
    fill: "#102F52",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.836,96.358 C235.954,96.358 237.671,98.077 237.671,100.197 C237.671,102.317 235.954,104.035 233.836,104.035 C231.718,104.035 230.001,102.317 230.001,100.197 C230.001,98.077 231.718,96.358 233.836,96.358 Z",
    id: "Path",
    fill: "#102F52",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.846,46.7449 C98.113,46.7449 99.14,47.7726 99.14,49.0404 C99.14,50.3082 98.113,51.3359 96.846,51.3359 C95.58,51.3359 94.553,50.3082 94.553,49.0404 C94.553,47.7726 95.58,46.7449 96.846,46.7449 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.213,30.9394 C174.545,30.9394 175.625,32.0205 175.625,33.354 C175.625,34.6875 174.545,35.7686 173.213,35.7686 C171.881,35.7686 170.801,34.6875 170.801,33.354 C170.801,32.0205 171.881,30.9394 173.213,30.9394 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.831,118.135 C74.488,118.135 75.02,118.668 75.02,119.325 C75.02,119.982 74.488,120.515 73.831,120.515 C73.175,120.515 72.643,119.982 72.643,119.325 C72.643,118.668 73.175,118.135 73.831,118.135 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.187,183.291 C100.189,183.291 101.001,184.104 101.001,185.107 C101.001,186.11 100.189,186.923 99.187,186.923 C98.185,186.923 97.373,186.11 97.373,185.107 C97.373,184.104 98.185,183.291 99.187,183.291 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.056,85.444 C165.056,84.118 166.131,83.043 167.455,83.043 C168.78,83.043 169.854,84.118 169.854,85.444 C169.854,86.771 168.78,87.846 167.455,87.846 C166.131,87.846 165.056,86.771 165.056,85.444 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.096,101.057 C206.466,101.057 207.577,102.169 207.577,103.541 C207.577,104.912 206.466,106.024 205.096,106.024 C203.725,106.024 202.614,104.912 202.614,103.541 C202.614,102.169 203.725,101.057 205.096,101.057 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0774,72.486 C20.4446,72.486 22.3637,74.0023 22.3637,75.8729 C22.3637,77.7434 20.4446,79.2598 18.0774,79.2598 C15.7101,79.2598 13.791,77.7434 13.791,75.8729 C13.791,74.0023 15.7101,72.486 18.0774,72.486 Z",
    id: "Path",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.928,165.814 C83.575,164.495 84.357,163.139 85.675,162.786 C86.992,162.433 88.347,163.215 88.7,164.534 C89.053,165.853 88.271,167.208 86.953,167.562 C85.636,167.915 84.281,167.132 83.928,165.814 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.781,134.769 L68.749,134.769 C68.561,132.101 66.579,132.06 66.579,132.06 C66.579,132.06 68.765,132.017 68.765,128.935 C68.765,132.017 70.951,132.06 70.951,132.06 C70.951,132.06 68.969,132.101 68.781,134.769 Z M140.311,148.726 L140.274,148.726 C140.053,145.534 137.728,145.485 137.728,145.485 C137.728,145.485 140.292,145.434 140.292,141.745 C140.292,145.434 142.856,145.485 142.856,145.485 C142.856,145.485 140.532,145.534 140.311,148.726 Z",
    id: "Shape",
    fill: "#8FB8C6",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteInsights);
export default __webpack_public_path__ + "static/media/complete-insights.d91b1426a576e3a42915510fa4872977.svg";
export { ForwardRef as ReactComponent };